export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
        "imagen" : "assets/imgs/lotus.jpg",
        "url" : "https://www.facebook.com/share/p/1HnKbmvLVR",
        "titulo" : "Secretaría de Contraloría Hidalgo",
        "fecha" : "Realizamos la segunda reunión trimestral de seguimiento al Sistema de Gestión de la Correspondencia 2026.",
    },

     {
        "imagen" : "assets/imgs/requisitos.jpg",
        "url" : "https://www.facebook.com/share/p/1CwVfwVvpE/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Si tienes entre 15 y 25 años, participa en el Concurso Nacional Transparencia en Corto 2026.",
    },
     {
        "imagen" : "assets/imgs/comiteshuejutla.jpg",
        "url" : "https://www.facebook.com/share/p/194AeBKayX/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Comités de Contraloría Social, con el propósito de fortalecer su participación en la vigilancia de las obras.",    
       
    }, 
    
    {
        "imagen" : "assets/imgs/brigadastransformacion.jpg",
        "url" : "https://www.facebook.com/share/p/1DVaoy8d9e/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : " Brigadas Transformación, supervisaron la entrega de las tarjetas de los programas estatales Para el Bienestar y el Desarrollo y Bienestar de Madres Trabajadoras.",
    },     
  
    {
        "imagen" : "assets/imgs/comitecontraloria.jpg",
         "url" : "https://www.facebook.com/reel/1795575601599515",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Las capacitaciones para los Comités de Contraloría Social llegan a las 7 regiones del estado con el objetivo de fortalecer el conocimiento.",
    },
   
    {
        "imagen" : "assets/imgs/entregachalecos.jpg",
         "url" : "https://www.facebook.com/share/p/1cvEZRhvtf",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Entrega de cascos y chalecos a las personas integrantes de los Comités de Contraloría Social",
    },

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]